import request from '@/util/request';
import qs from 'qs';

// 圈子-分页
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/social/circle/page', Object.assign({}, options, { params }));

// 圈子-详情
export const getDetailApi = (params, options) =>
  request.get('/api/v4ward/social/circle/detail', Object.assign({}, options, { params }));

// 圈子-新增
export const addApi = (params, options) =>
  request.post('/api/v4ward/social/circle/save', params, options, {
    ContentType: 'application/json',
  });

// 圈子-修改
export const updateApi = (params, options) =>
  request.post('/api/v4ward/social/circle/update', params, options, {
    ContentType: 'application/json',
  });

// 圈子-删除
export const delApi = (params, options) =>
  request.post('/api/v4ward/social/circle/remove', qs.stringify(params), options);

// 圈子-发布
export const releaseApi = (params, options) =>
  request.post('/api/v4ward/social/circle/publish', qs.stringify(params), options);

// 圈子-显示|不显示
export const visibleApi = (params, options) =>
  request.post('/api/v4ward/social/circle/update', params, options, {
    ContentType: 'application/json',
  });

// 圈子-回复列表
export const getReplyPageListApi = (params, options) =>
  request.get('/api/v4ward/social/circle/reply/page', Object.assign({}, options, { params }));

// 圈子-回复
export const replyApi = (params, options) =>
  request.post('/api/v4ward/social/circle/reply/save', params, options, {
    ContentType: 'application/json',
  });
